<template>
  <form class="t-refill" @submit="Submit($event)" :action="action" method="post">
    <h2>{{ balanceText.titleAdd }}</h2>
    <div class="t-input t-input_checkbox" :class="{_error: currency.error}" v-if="!props">
      <label>{{ currency.label }}</label>
      <div v-for="(radio, index) in currency.items" :key="'currency_radio_' + index">
        <input type="radio" v-model="currency.value" :value="radio.value" :id="'currency_' + index" class="t-radio" :name="currency.name">
        <label :for="'currency_' + index">{{ radio.title }}</label>
      </div>
    </div>


    <div class="t-input" :class="{_error: amount.error}">
      <label>{{ amount.label }}</label>
      <input v-model="amount.value" :placeholder="amount.placeholder" @focus="Focus()" :name="amount.name">
    </div>
    <p v-if="props && props.course">{{balanceText.refill_1}} {{money}} {{balanceText.refill_2}}</p>
    <button class="t-btn" :disabled="disabled"><span>{{ balanceText.confirmBtn }}</span></button>
  </form>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import {store} from '../../store'
    export default {
        props: ['props'],
        data(){
            return{
                disabled: false,
                action: '/site/tinkoff',

                currency: {
                    label: store.getters['staticText/balanceText'].confirmLabel,
                    name: "currency",
                    type: 'radio_list',
                    value: -1,
                    error: false,
                    items: []
                },

                amount: {
                    label: store.getters['staticText/balanceText'].amountTitle,
                    name: "amount",
                    type: 'text',
                    value: '',
                    placeholder: store.getters['staticText/balanceText'].amountPlaceholder,
                    error: false,
                    pattern: /^[0-9]{1,5}|^[0-9]{1,5}\.[0-9]{0,2}$/
                }
            }
        },
        computed: {
            ...mapGetters('staticText', ['balanceText']),
            ...mapGetters('handbook', ['currencyList']),
            ...mapGetters('profile', ['balance']),
            money() {
              // console.log(this.balance);
              return parseFloat(this.props.course.price) - parseFloat(this.balance.active_balance);
            }
        },
        methods:{
            ...mapActions('modal', ['modalDialogType_authOpen', 'modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            Submit(e){
                this.disabled = true;

                let is_valid = true;

                if (!this.amount.pattern.test(this.amount.value)) {
                    this.amount.error = true;
                    is_valid = false;
                }
                if ((this.currency.value === -1)&&(!this.props)) {
                    this.currency.error = true;
                    is_valid = false;
                }
                if(!is_valid){
                    e.preventDefault();
                    this.disabled = false;
                }
            },
            Focus(){
                this.amount.error = false
            }
        },
        mounted(){
            if (this.props && this.props.course) {
              this.currency.value = 1;
              this.amount.value = this.money;
            } else {
              for(let i = 0; i < this.currencyList.length; i++){
                this.currency.items.push(this.currencyList[i])
              }
            }
        }
    }
</script>

<style lang="sass">
.t-refill
  width: 320px
  margin: 0 auto
  padding: 24px
  @extend %substrate
</style>



// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Refill.vue